<script>
    import Cinema from "../components/Cinema.svelte";
    import { onMount } from "svelte";
    import ajaxFetch from "../services/ajaxFetch";

    let { variationId, index, featureIndex, errorCallback, performance, cinemaInjectionContainerWidth } = $props();

    let cinemaHasLoaded = $state(false);
    let headline = $state(),
        recommendations = $state(),
        tracking = $state(),
        additionalClickTracking = $state(),
        metaData = $state(),
        featuresState = $state();

    onMount(async () => {
        performance.cinemaLoadingStarted();
        const indexParam = index ? `&index=${index}` : "";
        const parameters = `${indexParam}`;
        const res = await ajaxFetch(`/reco-core/recommendations/basketlayer/variations/${variationId}` + parameters);
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({ headline, recommendations, tracking, additionalClickTracking, metaData, featuresState } = await res.json());
        cinemaHasLoaded = true;
    });
</script>

{#if cinemaHasLoaded}
    <Cinema
        class="content--full-bleed"
        {headline}
        {recommendations}
        {tracking}
        {featureIndex}
        {additionalClickTracking}
        {featuresState}
        {cinemaInjectionContainerWidth}
        cinemaIndex={index}
        cinemaMeta={metaData}
        {performance}
        site="reco_basketLayer"
        isExpandable={false}
    />

    <style lang="scss">
        .content--full-bleed {
            padding: 0;
        }
    </style>
{/if}
